import React from 'react';
import { Redirect } from 'react-router-dom';
import { createCompany, uploadLogo } from '../../actions/companies/apiRequests';
import {
  COUNTRY as defaultCountry,
  SUBSCRIPTION as defaultSubscription,
  COMPANY_ENABLED as defaultStatus,
} from '../../constants/defaults';
import withRoleRestrictions from '../shared/withRoleRestrictions';
import CompanyDetailsPage from './CompanyDetailsPage';
import { SPRUCE_ADMINS } from '../../constants/userRoles';
import withEulaRestrictions from '../license/withEulaRestrictions';

import { notifyError } from '../../utils/notifier';

export class AddCompanyPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: null,
    };
    this.onSave = this.onSave.bind(this);
  }

  onSave(company, logo) {
    return createCompany(company)
      .then(({ id }) => {
        this.uploadLogo(id, logo).then(() => this.setState({ companyId: id }));
      })
      .catch((error) => {
        notifyError(error.message);
      });
  }

  uploadLogo(id, file = null) {
    return file ? uploadLogo(id, file) : Promise.resolve();
  }

  render() {
    const { companyId } = this.state;
    return (
      <Choose>
        <When condition={companyId}>
          <Redirect
            to={{
              pathname: `/companies/${companyId}`,
              state: {
                created: true,
              },
            }}
          />
        </When>
        <Otherwise>
          <CompanyDetailsPage
            company={{
              country: defaultCountry,
              subscription: defaultSubscription,
              enabled: defaultStatus,
              rentalUnits: 0,
              purchasedUnits: 0,
            }}
            editUsers={false}
            editStatus={false}
            editIsn={true}
            showAdmins={false}
            showStatusButton={false}
            showSuccessNotification={false}
            showCounters={false}
            onSave={this.onSave}
            {...this.props}
          />
        </Otherwise>
      </Choose>
    );
  }
}

export default withEulaRestrictions(withRoleRestrictions(AddCompanyPage, SPRUCE_ADMINS));



// WEBPACK FOOTER //
// src/components/companyDetails/AddCompanyPage.jsx